import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import React from 'react'
import {Button, Form, InputGroup} from 'react-bootstrap'
import { TOTP } from "totp-generator"
import base32Encode from 'base32-encode'
import { Buffer } from 'buffer'
Buffer.from('anything','base64')

document.addEventListener("DOMContentLoaded", (event) => {
  document.getElementById('submitFormButton').click();
});

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      developerMode: false,
      iFrameUri: [],
      isFormSubmitted: false,
      isFrameSubmitted: false,
      generatingToken: false,
      cardId: 'L7ROCQ7AMZ6MT7B9',
      uniqueToken: '',
      apiKeyId: '68e05e04-a54d-479c-a85f-b7f6c7531598',
      apiKey: '11223344556677889900aabbccddeeff',
      totpKey: '3132333435363738393031323334353637383930313233343536373839303132',
      styleUrl: 'https://files.catbox.moe/eusfiu.css',
      fieldNames: "",
      loader: 'dots',
      source: 'awsTest',
      class: '',
      loadDefaultStyle: true,
      showPan: true,
      showCvv: true,
      showEmboss: true,
      showExpiry: true,
      showCopy: false,
      clickToCopy: false,
      showPreloadedData: true,
      iframeUrls: {
        awsTest: 'https://easylaunch.tst.meawallet.app/easylaunch',
        awsDev: 'https://easylaunch.dev.meawallet.app/easylaunch',
        awsTestOld: 'https://mcd.tst.meawallet.app/easylaunch',
        awsDevOld: 'https://mcd.dev.meawallet.app/easylaunch',
        localhost: 'http://localhost:5173'
      },
      iframeUrl: '',
    }
  };

  handleCardIdChange = (e => {
    this.setState({ cardId: e.target.value });
  })

  handleSourceChange = (e => {
    this.setState({ source: e.target.value });
  })

  handleTotpKeyChange = (e => {
    this.setState({ totpKey: e.target.value });
  })

  secretGen = (() => {
    this.setState({ uniqueToken: '' });
    this.setState({ uniqueToken: this.generateTOTPSecret(this.state.totpKey, this.state.cardId) });
  })

  generateTOTPSecret(totpKeyHex, cardId, totpKeyId = '001', hmacHashAlg = 'sha-512') {
    const cardIdInHex = this.bytesToHex(Buffer.from(cardId)).substring(0, 64);
    const secretKeyHex = totpKeyHex + cardIdInHex;
    const secretKeyBytes = this.hexToBytes(secretKeyHex);

    const base32Secret = base32Encode(secretKeyBytes, 'RFC4648', { padding: false });

    // Set TOTP options
    const token= TOTP.generate(base32Secret, {
      digits: 8,
      algorithm: "SHA-512",
      period: 60,
      timestamp: Date.now()
    })
    return `${totpKeyId}#${token.otp}`;
  }

  hexToBytes(hex) {
    return Buffer.from(hex.replace(/\s+/g, ''), 'hex');
  }

  bytesToHex(buffer, addSpace = false) {
    const hex = buffer.toString('hex').toUpperCase();
    if (addSpace) {
      return hex.match(/.{1,2}/g).join(' ');
    }
    return hex;
  }

  initListener = event => {
    window.addEventListener('message', event => {
      let url = new URL(this.state.iframeUrl)
      if (event.origin === url.origin) {
          console.log(event.data)
      }
    }, false);
  }

  submitFrame = event => {
    event.preventDefault();
    let iFrameData = []
    for (let i = 0; i < 6; i++) {
      iFrameData.push(
          btoa(JSON.stringify({
            cardId: event.target.elements.formCardId.value,
            uniqueToken: event.target.elements.formToken.value,
            apiKeyId: event.target.elements.formApiKeyId.value,
            apiKey: event.target.elements.formApiKey.value,
            fieldNames: i === 0 ? encodeURIComponent(event.target.elements.formFieldNames.value) : '',
            styleUrl: i === 0 ? event.target.elements.formStyling.value : "https://files.catbox.moe/dvqmwq.css",
            loader: i === 0 ? event.target.elements.formLoader.value : 'dots',
            class: i ? 'iframe-' + i : event.target.elements.formClass.value,
            loadDefaultStyle: event.target.elements.loadDefaultStyle.checked,
            showPan: i === 0 ? event.target.elements.formShowPan.checked : i === 2,
            showCvv: i === 0 ? event.target.elements.formShowCvv.checked : i === 1,
            showEmboss: i === 0 ? event.target.elements.formShowEmboss.checked : i === 4,
            showExpiry: i === 0 ? event.target.elements.formShowExpiry.checked : i === 3,
            showCopy: i === 0 ? event.target.elements.formShowCopy.checked : ( i === 2 || i === 4 ),
            clickToCopy: i === 0 ? event.target.elements.formClickToCopy.checked : i === 1,
            showPreloadedData: i === 0 ? event.target.elements.formPreloadedData.checked : ( i === 1 || i === 2 || i === 5 ),
          }))
      )
    }
    let sourceUrl = ''
    if (this.state.developerMode) {
      sourceUrl = this.state.iframeUrls.localhost
    } else {
      switch (this.state.source) {
        case "awsTestOld":
          sourceUrl = this.state.iframeUrls.awsTestOld
          break;
        case "awsDevOld":
          sourceUrl = this.state.iframeUrls.awsDevOld
          break;
        case "awsDev":
          sourceUrl = this.state.iframeUrls.awsDev
          break;
        case "awsTest":
          sourceUrl = this.state.iframeUrls.awsTest
          break;
        default:
          break;
      }
    }
    this.setState({
      iframeUrl: sourceUrl
    })
    this.setState({
      iFrameUri: iFrameData
    })
    this.setState({
      isFrameSubmitted: true
    })
  }
  backButtonFrame = event => {
    event.preventDefault();
    this.setState({
      isFrameSubmitted: false
    })
  }

  render() {
    if (!this.state.uniqueToken) {
      this.secretGen()
    }
    const isFrameSubmitted = this.state.isFrameSubmitted;
    return (
      <div className="App">
        <header className="App-header iframe-demo">
          { !isFrameSubmitted ? (
          <span>
            <div className="easy-launch-title">EasyLaunch iFrame Demo version</div>
            <span>
              <Form onSubmit={this.submitFrame} className="react-easy-launch-form">
                <Form.Group className="mb-0" controlId="formCardId">
                  <Form.Label className="mb-0">cardId</Form.Label>
                  <Form.Control type="text" size="sm" defaultValue={this.state.cardId} onChange={this.handleCardIdChange}/>
                </Form.Group>
                <Form.Group className="mb-0  mt-1" controlId="formToken">
                  <Form.Label className="mb-0">secret</Form.Label>
                  <InputGroup size="sm">
                    <Form.Control type="text" size="sm" defaultValue={this.state.uniqueToken}/>
                    <Button variant="outline-secondary" id="button-addon" className='generate-button' onClick={this.secretGen}>
                      Generate
                    </Button>
                  </InputGroup>
                </Form.Group>
                <Form.Group className="mb-0 mt-1" controlId="formApiKeyId">
                  <Form.Label className="mb-0">apiKeyId</Form.Label>
                  <Form.Control type="text" size="sm" defaultValue={this.state.apiKeyId}/>
                </Form.Group>
                <Form.Group className="mb-0 mt-1" controlId="formApiKey">
                  <Form.Label className="mb-0">apiKey</Form.Label>
                  <Form.Control type="text" size="sm" defaultValue={this.state.apiKey}/>
                </Form.Group>
                <Form.Group className="mb-0 mt-1" controlId="totpKey">
                  <Form.Label className="mb-0">totpKey</Form.Label>
                  <Form.Control type="text" size="sm" defaultValue={this.state.totpKey} onChange={this.handleTotpKeyChange}/>
                </Form.Group>
                <Form.Group className="mb-0 mt-1" controlId="formFieldNames">
                  <Form.Label className="mb-0">Field names</Form.Label>
                  <Form.Control type="text" size="sm" placeholder={'Object with field names'} defaultValue={this.state.fieldNames}/>
                  <Form.Text className="text-muted">
                    Ex: &#123;"pan": "PAN:", "emboss": "Cardholder:", "exp": "Expiry:", "cvv": "CVV:", "details": "Show card details", "clickToCopyText": "Click to copy", "clickToCopyCopied": "Copied to clipboard!":&#125;
                  </Form.Text>
                </Form.Group>
                <Form.Group className="mb-0 mt-1" controlId="formStyling">
                  <Form.Label className="mb-0">Styling</Form.Label>
                  <Form.Control type="text" size="sm" placeholder={'Link to style file'} defaultValue={this.state.styleUrl}/>
                </Form.Group>
                <Form.Group className="mb-0 mt-1" controlId="formClass">
                  <Form.Label className="mb-0">Class</Form.Label>
                  <Form.Control type="text" size="sm" placeholder={'Custom global class'}/>
                </Form.Group>
                <Form.Group className="mb-0 mt-1" controlId="formLoader">
                  <Form.Label>Loader style</Form.Label>
                  <Form.Select defaultValue={this.state.loader}>
                    <option value="dots">Dots</option>
                    <option value="spinner">Spinner</option>
                    <option value="bars">Bars</option>
                    <option value="none">No Loader</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-0 mt-1 mt-2" controlId="requestSource">
                  <Form.Label>Request Source</Form.Label>
                  <Form.Select defaultValue={this.state.source} onChange={this.handleSourceChange}>
                    <option value="awsTest">AWS Test</option>
                    <option value="awsDev">AWS Dev</option>
                    <option value="awsTestOld">AWS Test Old</option>
                    <option value="awsDevOld">AWS Dev Old</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mt-3" controlId="loadDefaultStyle">
                  <Form.Check
                      defaultChecked={this.state.loadDefaultStyle}
                      type="checkbox"
                      label="Load Default CSS Style"
                  />
                </Form.Group>
                <Form.Group controlId="formShowPan">
                  <Form.Check
                      defaultChecked={this.state.showPan}
                      type="checkbox"
                      label="Show PAN"
                  />
                </Form.Group>
                <Form.Group controlId="formShowCvv">
                  <Form.Check
                      defaultChecked={this.state.showCvv}
                      type="checkbox"
                      label="Show CVV"
                  />
                </Form.Group>
                <Form.Group controlId="formShowEmboss">
                  <Form.Check
                      defaultChecked={this.state.showEmboss}
                      type="checkbox"
                      label="Show Emboss"
                  />
                </Form.Group>
                <Form.Group controlId="formShowExpiry">
                  <Form.Check
                      defaultChecked={this.state.showExpiry}
                      type="checkbox"
                      label="Show Expiry"
                  />
                </Form.Group>
                <Form.Group controlId="formShowCopy">
                  <Form.Check
                      defaultChecked={this.state.showCopy}
                      type="checkbox"
                      label="Show Copy Button"
                  />
                </Form.Group>
                <Form.Group controlId="formClickToCopy">
                  <Form.Check
                      defaultChecked={this.state.clickToCopy}
                      type="checkbox"
                      label="Click on Value to Copy"
                  />
                </Form.Group>
                <Form.Group controlId="formPreloadedData">
                  <Form.Check
                      defaultChecked={this.state.showPreloadedData}
                      type="checkbox"
                      label="Show Preloaded Data"
                  />
                </Form.Group>
                <br/>
                <br/>
                <Button className="mt-3 mb-5" variant="primary" type="submit" id="submitFormButton">
                  Submit
                </Button>
                <br/><br/><br/>
              </Form>
            </span>
          </span>
          ) : (
            <span>
              <div className="single-iframe-container">
                <div className="easy-launch-title">Single iFrame</div>
                <iframe src={this.state.iframeUrl + "?var=" + Math.random() + "&data=" + this.state.iFrameUri[0]} title="easylaunch-iframe" width="400px" height="225px" allow={"clipboard-write "  + this.state.iframeUrl } onLoad={this.initListener} />
              </div>
              <div className="multiple-iframe-container">
                <div className="easy-launch-title">Multiple iFrames</div>
                  <small className='multiple-iframe-notification'>Configuration is not applied to multiple iFrames in this Demo.</small><br/>
                  <div>
                    <iframe src={this.state.iframeUrl + "?var=" + Math.random() + "&data=" + this.state.iFrameUri[1]}
                            title="easylaunch-iframe" width="310px" height="35px" className="multiple-frames"
                            allow={"clipboard-write " + this.state.iframeUrl}/>
                  </div>
                  <div>
                    <iframe src={this.state.iframeUrl + "?var=" + Math.random() + "&data=" + this.state.iFrameUri[2]}
                            title="easylaunch-iframe" width="310px" height="35px" className="multiple-frames"
                            allow={"clipboard-write " + this.state.iframeUrl}/>
                  </div>
                  <div>
                    <iframe src={this.state.iframeUrl + "?var=" + Math.random() + "&data=" + this.state.iFrameUri[3]}
                            title="easylaunch-iframe" width="310px" height="35px" className="multiple-frames"/>
                  </div>
                  <div>
                    <iframe src={this.state.iframeUrl + "?var=" + Math.random() + "&data=" + this.state.iFrameUri[4]}
                            title="easylaunch-iframe" width="310px" height="35px"
                            allow={"clipboard-write " + this.state.iframeUrl} className="multiple-frames"/>
                  </div>
                  <div className="easy-launch-title my-2">Get Pin iFrame</div>
                  <div>
                  <iframe
                      src={this.state.iframeUrl + "?var=" + Math.random() + "&type=showPin&data=" + this.state.iFrameUri[5]}
                      title="easylaunch-iframe" width="310px" height="35px" className="multiple-frames"/>
                </div>
              </div>
              <Form onSubmit={this.backButtonFrame}>
                <Button className="configure-button" variant="primary" type="submit">
                  Configure
                </Button>
              </Form>
            </span>
          )}
        </header>
      </div>
    );
  }
}

export default App;
